<template>
<m-pageframe
    title="Test Eula Signatures"
>
<v-container>

    <v-btn
        v-on:click="viewEulaSignature"
        style="margin-right: 15px"
    >
        View Current Signature
    </v-btn>

     <v-btn
        v-on:click="signEula"
        color="primary"
        style="margin-right: 15px"
    >
        Sign
    </v-btn>

    <br/>
    <br/>

    <v-btn
        v-on:click="deleteSignature"
        style="margin-right: 15px"
    >
        Delete Most Recent Signature (Sys Admin Only)
    </v-btn>


    <m-eula-view-dialog
        ref="m-eula-view-dialog"
    />

    <m-eula-sign-dialog
        ref="m-eula-sign-dialog"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
        }
    },

    methods: {
        viewEulaSignature() {
            this.$refs['m-eula-view-dialog'].showDialog(this.$rc.$state.employee_id);
        },

        deleteSignature() {
            this.$rc.deleteCurrentEulaSignature(
                this.$rc.$state.employee_id,

                () => {
                    this.$rc.alert('Signature Deleted', 'The current EULA signature for the active user has been deleted');
                },

                () => {
                    this.$rc.alert('Error', 'Unable to delete the current EULA signature.  Check that you are logged in as a systems administrator.');
                },
            );
        },

        signEula()
        {
            this.$refs['m-eula-sign-dialog'].showDialog(this.$rc.$state.employee_id);
        },

    },
    
}

</script>

<style lang="scss" scoped>

</style>